import React from 'react';
import { getPanelComponent } from './panelRegistry';
import { ChevronLeftIcon, ChevronRightIcon } from './SidebarIcons';

const RightSidebar = ({
  panelType,
  panelProps = {},
  onClose,
  className = '',
  onMouseEnter,
  onMouseLeave,
  onPointerDown,
  collapsed = false,
  onToggleCollapse,
}) => {
  if (!panelType) return null;

  const PanelComponent = getPanelComponent(panelType);

  if (!PanelComponent) {
    console.warn(`RightSidebar: Panel type "${panelType}" is not registered.`);
    return null;
  }

  const canCollapse = typeof onToggleCollapse === 'function';

  // The w-full lg:w-2/5 flex-shrink-0 is enforced here to maintain absolute design consistency.
  return (
    <div
      className={`fixed inset-0 lg:relative lg:inset-auto lg:flex lg:w-2/5 flex-shrink-0 flex flex-col bg-white dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700 z-50 lg:z-0 lg:shadow-none shadow-2xl min-w-0 ${
        collapsed ? 'lg:!w-5 lg:!min-w-[1.25rem] lg:overflow-visible' : 'overflow-hidden'
      } ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onPointerDown={onPointerDown}
    >
      {canCollapse && (
        <button
          type="button"
          onClick={onToggleCollapse}
          className={`hidden lg:flex absolute top-1/2 -translate-y-1/2 z-[60] h-12 w-5 items-center justify-center border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-500 hover:text-primary-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700 shadow-sm transition-colors ${
            collapsed
              ? 'left-0 rounded-l-md border-r-0'
              : 'left-0 rounded-r-md border-l-0'
          }`}
          title={collapsed ? 'Expand panel' : 'Collapse panel'}
          aria-label={collapsed ? 'Expand panel' : 'Collapse panel'}
          aria-expanded={!collapsed}
        >
          {collapsed ? (
            <ChevronLeftIcon className="w-4 h-4" />
          ) : (
            <ChevronRightIcon className="w-4 h-4" />
          )}
        </button>
      )}
      <div className={`flex flex-col h-full min-h-0 min-w-0 overflow-hidden ${collapsed ? 'lg:hidden' : ''}`}>
        <PanelComponent {...panelProps} onClose={onClose} />
      </div>
    </div>
  );
};

export default RightSidebar;
